import axios, { Method } from 'axios';

const Config = window.VBwidgetConfig;
const API_BROKER_URL = Config.broker;
const API_EXTERNAL_URL = Config.externalApi;

interface BrokerApiPropsType {
    method?: Method;
    controller: string;
    timeout?: number;
    data?: any;
    auth?: {
        username: string;
        password: string;
    };
    headers?: {
        [key: string]: string;
    };
    onUploadProgress?: (event: ProgressEvent) => void;
}

export default class Request {
    public callBrokerApi = (props: BrokerApiPropsType) => {
        const username = process.env.BROKER_USERNAME;
        const password = process.env.BROKER_PASSWORD;

        const {
            method = 'POST',
            timeout = 30000,
            data = null,
            controller,
            auth = {
                username,
                password,
            },
            headers = {},
        } = props;

        return axios({
            method,
            headers,
            url: API_BROKER_URL + controller,
            timeout,
            data,
            auth,
            onUploadProgress: (event: ProgressEvent) => {
                if (!props.onUploadProgress) {
                    return;
                }

                props.onUploadProgress(event);
            },
        })
            .then((result) => result.data)
            .catch(this.errorHandler);
    };

    public callExternalApi = (props: BrokerApiPropsType) => {
        const username = process.env.EXT_USERNAME;
        const password = process.env.EXT_PASSWORD;

        const {
            method = 'POST',
            timeout = 30000,
            data = null,
            controller,
            auth = {
                username,
                password,
            },
            headers = {},
        } = props;

        return axios({
            method,
            headers,
            url: API_EXTERNAL_URL + controller.replace(/^\/+/, ''),
            timeout,
            data: {
                params: data,
            },
            auth,
            onUploadProgress: (event: ProgressEvent) => {
                if (!props.onUploadProgress) {
                    return;
                }

                props.onUploadProgress(event);
            },
        })
            .then((result) => result.data)
            .catch(this.errorHandler);
    };

    private errorHandler = (error: any) => {
        if (error.response && error.response.status === 401) throw new Error('Необходимо авторизоваться в системе!');
        if (error.response && error.response.status === 404) throw new Error('Сервер недоступен!');
        if (
            error.response &&
            error.response.data &&
            error.response.data.message
        ) throw new Error(error.response.data.message);
        throw new Error(error.message);
    };
}
